export default __webpack_public_path__ + "static/media/Cars_11.f76a826f.png";